import { ScanLogType } from "../../app.enums";
import { modalMessage } from "../../app.modal-messages";
import { MilkBottleModel } from "../../models/milk.model";
import { isCombinable } from "../../utils/milk-label.util";
import { ScanMilkBottleValidationError } from "./scan-validation-error";
import { IScanValidation } from "./scan-validation.model";

export function CheckCombinable() {
	return function (
		target: any,
		propertyKey: string,
		descriptor: PropertyDescriptor
	) {
		const originalMethod = descriptor.value;

		descriptor.value = async function (...args: IScanValidation[]) {
			const [obj] = args;

			if (obj.milkBottle instanceof MilkBottleModel) {
				try {
					await isCombinable(obj.milkBottle, obj.milkBottles);
				} catch (error) {
					throw new ScanMilkBottleValidationError(
						ScanLogType.Milk_Bottle_Incompatible_Contents,
						modalMessage.milk_combine(obj.milkBottle)
					);
				}
			}

			return originalMethod.apply(this, args);
		};
	};
}
